import {getRideApi} from "api";


export const rideBilling = (billingId) => ({
    types: ['RIDE_BILLING_REQUEST', 'RIDE_BILLING_SUCCESS', 'RIDE_BILLING_FAILURE'],
    callAPI: () => getRideApi().getBilling({billingId: billingId})
})

export const fetchTrips = (page, size) => ({
    types: ['FETCH_TRIPS_REQUEST', 'FETCH_TRIPS_SUCCESS', 'FETCH_TRIPS_FAILURE'],
    callAPI: () => getRideApi().listRides({page: page, size: size})
});

export const getVehicleDetails = (vehicleId) => ({
    types: ['VEHICLE_DETAILS_REQUEST', 'VEHICLE_DETAILS_SUCCESS', 'VEHICLE_DETAILS_FAILURE'],
    callAPI: () => getRideApi().getVehicle({vehicleId: vehicleId})
});

export const lock = () => ({
    types: ['RIDE_LOCK_REQUEST', 'RIDE_LOCK_SUCCESS', 'RIDE_LOCK_FAILURE'],
    callAPI: () => getRideApi().rideLock()
});

export const unlock = () => ({
    types: ['RIDE_UNLOCK_REQUEST', 'RIDE_UNLOCK_SUCCESS', 'RIDE_UNLOCK_FAILURE'],
    callAPI: () => getRideApi().rideUnlock()
});

export const fetchFullRide = (rideId) => ({
    types: ['FETCH_RIDE_REQUEST', 'FETCH_RIDE_SUCCESS', 'FETCH_RIDE_FAILURE'],
    callAPI: () => getRideApi().getFullRideDetail({rideId: rideId})
});

export const fetchUserRidesSummary = () => ({
    types: ['FETCH_USER_RIDES_SUMMARY_REQUEST', 'FETCH_USER_RIDES_SUMMARY_SUCCESS', 'FETCH_USER_RIDES_SUMMARY_FAILURE'],
    callAPI: () => getRideApi().getUserRidesSummary()
});

export const rideStarted = () =>({
    type: "RIDE_STARTED",
})